import { render } from "./AccountMain.vue?vue&type=template&id=68098687&scoped=true"
import script from "./AccountMain.vue?vue&type=script&lang=js"
export * from "./AccountMain.vue?vue&type=script&lang=js"

import "./AccountMain.vue?vue&type=style&index=0&id=68098687&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68098687"]])

export default __exports__